import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import secureLocalStorage from "react-secure-storage";

// Types
export interface UserMe {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
}

export interface Session {
  access_token: string;
  expires_in: number;
  token_type: string;
  scope: string;
  refresh_token: string;
}

export interface Auth {
  session?: Session;
  user_me?: UserMe;
  loading: boolean;
}

let parsedLS: Partial<Auth> = {};
const raw = secureLocalStorage.getItem('auth');

if (typeof raw === 'string') {
  try {
    parsedLS = JSON.parse(raw);
  } catch (e) {
    console.warn("Could not parse auth from secureLocalStorage:", e);
    parsedLS = {};
  }
} else if (typeof raw === 'object' && raw !== null) {
  parsedLS = raw as Partial<Auth>;
}

// Initial state
const initialState: Auth = {
  session: parsedLS.session,
  user_me: parsedLS.user_me,
  loading: false,
};

// Slice
export const sessionSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authloading: (state, action: PayloadAction<Auth>) => {
      state.loading = action.payload.loading;
    },
    login: (state, action: PayloadAction<Auth>) => {
      state.user_me = action.payload.user_me;
      state.session = action.payload.session;
    },
    logout: (state) => {
      state.session = undefined;
      state.user_me = undefined;
      state.loading = false;
    },
    refresh_token: (state, action: PayloadAction<Session>) => {
      state.session = action.payload;
    },
  },
});

// Exports
export const { login, logout, refresh_token, authloading } = sessionSlice.actions;
export const selectAuth = (state: RootState) => state.auth;
export default sessionSlice.reducer;
